import "../styles/Menu.css";

function Menu() {

const dishes = [
{
name: "Butter Chicken",
price: "₹350",
spice: "🌶🌶",
rating: "⭐ 4.8",
chef: true,
image: "https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?auto=format&fit=crop&w=800&q=80",
description: "Creamy tomato chicken curry."
},

{
name: "Paneer Tikka",
price: "₹250",
spice: "🌶🌶",
rating: "⭐ 4.6",
chef: false,
image: "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?auto=format&fit=crop&w=800&q=80",
description: "Grilled paneer cubes with spices."
},

{
name: "Biryani",
price: "₹300",
spice: "🌶🌶🌶",
rating: "⭐ 4.7",
chef: true,
image: "https://images.unsplash.com/photo-1631515243349-e0cb75fb8d3a?auto=format&fit=crop&w=800&q=80",
description: "Fragrant basmati rice with rich spices."
},

{
name: "Masala Dosa",
price: "₹150",
spice: "🌶",
rating: "⭐ 4.5",
chef: false,
image: "https://images.unsplash.com/photo-1668236543090-82eba5ee5976?auto=format&fit=crop&w=800&q=80",
description: "Crispy dosa with spicy potato filling."
},

{
  name: "Gulab Jamun",
  price: "₹120",
  spice: "🍯 Sweet",
  rating: "⭐ 4.9",
  chef: false,
 image: "https://images.unsplash.com/photo-1666190092159-3171cf0fbb12?auto=format&fit=crop&w=800&q=80",
  description: "Soft fried milk-solid balls soaked in sugar syrup."
}
];

return (
  <div className="menu-container">

    <h1 className="menu-title">Our Menu 🍽</h1>

    <div className="menu-grid">

      {dishes.map((dish, index) => (
        <div className="menu-card" key={index}>
          

          {dish.chef && <span className="chef-badge">Chef Special 👨‍🍳</span>}

          <img src={dish.image} alt={dish.name} />

          <h3>{dish.name}</h3>

          <p>{dish.description}</p>

          <p>{dish.spice}</p>

          <p>{dish.rating}</p>

          <p className="price">{dish.price}</p>

          <button>Add to Cart</button>

        </div>
      ))}

    </div>

  </div>
);
}

export default Menu;